import { Injectable } from '@angular/core';

import { type Permissions } from '../../../../features/auth/models/login-response.model';

@Injectable({
  providedIn: 'root'
})
export class RbacService {

  private permissions: Permissions[] = [];
  

  constructor() { }


  setPermissions(permissions: Permissions[]) {
    this.permissions = permissions;
  }

  hasPermission(requiredPermission: string): boolean {
    const [module, action] = requiredPermission.split('.');
    const modulePermission = this.permissions.find(p => p.module_name === module);
    return !!modulePermission && modulePermission.actions.includes(action);
  }

  
}